export default __webpack_public_path__ + "static/media/CNo.64-0.a1e15381.jpg";